import React from "react";
import { useCSOrderListTemplate } from "hooks/notification/csOrderList";
import SPButton from "../../../carRental/base/SPButton";

interface IComponentProps {
  data?: any;
  permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = (props) => {
  const { data, permission } = props;

  const { tableActionView } = useCSOrderListTemplate();

  const onView = () => {
    tableActionView(data);
  };

  return (
    <>
      {/*todo: 修改此处权限*/}
      <SPButton
        permissionKey="view-case"
        permission={permission}
        type="link"
        onClick={onView}
      >
        查看
      </SPButton>
    </>
  );
};

export default SPTableActionBar;
